import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import useIsMobile from "../../hooks/useIsMobile";
import usePageTracking from "../pageTracking";

const StepDadosContrato = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const isMobile = useIsMobile();
  usePageTracking();
  return (
    <>
      <div className="text-center">
        <h3 className="mb-3">
          <b>3º Passo:</b> Sobre seu contrato.
        </h3>
        <p className="mb-3">Vamos falar sobre seu contrato, é rápido:</p>
      </div>

      <div className="row g-3">
        <div className={isMobile ? "" : "col-2"}></div>
        <div className={isMobile ? "col-12" : "col-4"}>
          <div className="row mb-1">
            <div className="col-12">
              <div className="form-floating">
                <input
                  id="edtDataContrato"
                  type="date"
                  placeholder="Data do contrato"
                  className={`form-control `}
                  {...register("dataContrato", {
                    required: "Data do contrato é obrigatória",
                  })}
                />
                <label htmlFor="edtDataContrato">Data do contrato</label>
                {errors.dataContrato && (
                  <div className="invalid-feedback">
                    {errors.dataContrato.message}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-12">
              <div className="form-floating">
                <input
                  id="edtTotalParcelas"
                  type="number"
                  min={0}
                  placeholder="Total de parcelas"
                  className={`form-control ${
                    errors.quantidadeTotalParcelas ? "is-invalid" : ""
                  }`}
                  {...register("quantidadeTotalParcelas", {
                    required: "Total de Parcelas é obrigatório",
                  })}
                />
                <label htmlFor="edtTotalParcelas">Total de parcelas</label>
                {errors.quantidadeTotalParcelas && (
                  <div className="invalid-feedback">
                    {errors.quantidadeTotalParcelas.message}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="form-floating">
                <input
                  id="edtQuantidadeParcelasPagas"
                  type="number"
                  className={`form-control ${
                    errors.quantidadeParcelasPagas ? "is-invalid" : ""
                  }`}
                  {...register("quantidadeParcelasPagas", {
                    required: "Quantidade de parcelas pagas é obrigatório",
                  })}
                />
                <label htmlFor="edtQuantidadeParcelasPagas">
                  Quantidade de parcelas pagas
                </label>
                {errors.quantidadeParcelasPagas && (
                  <div className="invalid-feedback">
                    {errors.quantidadeParcelasPagas.message}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={isMobile ? "col-12 mt-1" : "col-4"}>
          <div className="row mb-1">
            <div className="col-12">
              <Controller
                name="valorUltimaParcelaPaga"
                control={useFormContext().control}
                rules={{
                  required: "Valor da última parcela paga é obrigatório",
                }}
                render={({ field }) => (
                  <div className="form-floating">
                    <NumericFormat
                      {...field}
                      id="edtValorUltimaParcelaPaga"
                      className={`form-control ${
                        errors.valorUltimaParcelaPaga ? "is-invalid" : ""
                      }`}
                      placeholder="R$ 0,00"
                      thousandSeparator="."
                      decimalSeparator=","
                      prefix="R$ "
                      decimalScale={2}
                      fixedDecimalScale
                      allowNegative={false}
                      onValueChange={(values) => {
                        field.onChange(values.floatValue); // envia valor numérico limpo
                      }}
                    />
                    <label htmlFor="edtValorUltimaParcelaPaga">
                      Valor da última parcela paga
                    </label>
                    {errors.valorUltimaParcelaPaga && (
                      <div className="invalid-feedback">
                        {errors.valorUltimaParcelaPaga.message}
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
          </div>

          <div className="row g">
            <div className="col-12">
              <div className="form-floating">
                <select
                  id="cmbMotivoRescisao"
                  className="form-select fs-6"
                  {...register("motivoDistrato", {
                    required: "Motivo da rescisão é obrigatório",
                  })}
                  defaultValue="0"
                  aria-label=""
                >
                  <option value="0">Selecione o motivo do distrato</option>
                  <option value="1">Estou em atraso com o pagamento</option>
                  <option value="2">Atraso das obras</option>
                  <option value="3">Quero cancelar o contrato</option>
                  <option value="4">Outro motivo</option>
                </select>
                <label htmlFor="cmbMotivoRescisao" className="col-form-label">
                  Motivo do distrato
                </label>
              </div>
            </div>
          </div>

          <div className={`row g-3 ${isMobile ? "mt-1 mb-3" : "mt-1"}`}>
            <div className="col-12">
              <input
                className="form-check-input custom-check-input-lg"
                {...register("usaOuConstruiuNoImovel", {})}
                type="checkbox"
                value=""
                id="chkUsaOuEdificouImovel"
              />
              <label
                htmlFor="chkUsaOuEdificouImovel"
                className="form-check-label ms-2"
                style={{ fontSize: "0.8rem" }}
              >
                Você construiu ou usa o imóvel?
              </label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepDadosContrato;
